import { Stack, Typography } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import moment from 'moment-timezone';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { FC, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  name: string;
  filters: Record<string, any>;
  onChange: (value: SetStateAction<any>) => void;
  label?: string;
  labelFrom?: string;
  labelUntil?: string;
};

export const DateRange: FC<Props> = ({ label, labelFrom, labelUntil, name, filters, onChange }) => {
  const { t, i18n } = useTranslation();

  if (!label) label = t('Date Range');
  if (!labelFrom) labelFrom = t('From');
  if (!labelUntil) labelUntil = t('Until');

  const handleRangeChange = (value: moment.Moment | null, field: string) => {
    const fieldName = `${name}${field}`;
    const newValue = moment(value).isValid() ? value : null;

    onChange((prevState: Record<string, any>) => ({
      ...prevState,
      page: 0,
      [fieldName]: newValue?.toISOString() ?? '',
      [name]: {
        ...(prevState[name] ?? {}),
        [field.toLowerCase()]: newValue,
      },
    }));
  };

  return (
    <Stack>
      <Typography variant="subtitle2" sx={{ mb: 1.5 }}>
        {label}
      </Typography>

      <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={i18n.language}>
        <Stack spacing={2.5} direction="row">
          <DatePicker
            label={labelFrom}
            name={`${name}From`}
            value={filters?.[`${name}From`]?.length ? moment(filters?.[name]?.from) : null}
            onChange={(newValue) => handleRangeChange(newValue, 'From')}
          />

          <DatePicker
            label={labelUntil}
            name={`${name}Until`}
            value={filters?.[`${name}Until`]?.length ? moment(filters?.[name]?.until) : null}
            onChange={(newValue) => handleRangeChange(newValue, 'Until')}
          />
        </Stack>
      </LocalizationProvider>
    </Stack>
  );
};
